import { jsx as _jsx } from "react/jsx-runtime";
/**
 * DensityBar — rule-density meter for a coverage cell (faithful port of the back-office
 * DensityBar). Fill width scales with `count/max`; colour follows the coverage state.
 * `empty` renders a flat, zero-width track.
 */
const STATE_COLOR = {
    covered: 'var(--cov-covered)',
    thin: 'var(--cov-thin)',
    empty: 'var(--cov-empty)',
};
export function DensityBar({ count, max = 200, state }) {
    const pct = state === 'empty' ? 0 : Math.max(6, Math.min(100, (count / max) * 100));
    return (_jsx("div", { style: { height: 4, background: 'var(--bg-sunken)', borderRadius: 2, overflow: 'hidden' }, children: _jsx("div", { style: {
                width: pct + '%',
                height: '100%',
                background: STATE_COLOR[state],
                opacity: state === 'empty' ? 0 : 0.85,
            } }) }));
}
//# sourceMappingURL=DensityBar.js.map